import AlertManager from "../managers/alert/alert-manager";

export default class ApiBase {

    constructor() {
        this.defaultError = 'System Error';

        this.defaultValidationHandler = errors => {
            console.error(errors)
        }
    }


    handleError(error = this.defaultError) {
        AlertManager.error(error);
        throw new Error(error);
    }

    call(method, path, params, validationCallback = this.defaultValidationHandler, shouldReport) {
        return this.handleResponse(
            () => {
                return axios.post('/api/connector/call', {
                    path,
                    params,
                    method
                })
            },
            validationCallback,
            shouldReport
        );
    }

    get(path, params) {
        return this.call('get', path, params);
    }

    post(path, params, validationCallback, shouldReport) {
        return this.call('post', path, params, validationCallback, shouldReport);
    }

    delete(path, params) {
        return this.call('delete', path, params);
    }

    async handleResponse(caller, validationCallback = this.defaultValidationHandler, shouldReport = false) {
        try {
            return await caller();

        } catch (error) {

            if(error.message === 'canceled') {
                return false;
            }

            const { response } = error;

            if (response?.status === 422) {
                validationCallback(response.data.errors);

                if (window.Bugsnag !== null) {
                    window.Bugsnag.notify(response.data.errors);
                }

                AlertManager.error('Validation Error');

                if (shouldReport) {
                    throw new Error('Validation');
                }

                return false;
            }

            if (window.Bugsnag !== null) {
                window.Bugsnag.notify(error);
            }

            this.handleError(response);
        }
    }
}
